import h from "../core/createElement";

export default function InputSideLabel({ shared={}, name="labelinput", type, items = [], onKeydown, placeholder = "", onKeyup, title, onChange, defaultValue }) {
    let input;

    const InputSide = (
        <article class="custom-label">
            <span class="title">{title}</span>
            {input = type == "select" ?
                <select onChange={onChange}>
                    {_.map(items, e => <option value={e.value}>{e.label}</option>)}
                </select>
                :
                <input type={type} onKeydown={onKeydown} placeholder={placeholder} onKeyup={onKeyup} />
            }
        </article>
    );

    shared[name] = {
        set_value: v => input.value = v
    };

    if (defaultValue != undefined) input.value = defaultValue;

    return InputSide;
}